import { RAISE_API_V1_URL } from "constants/endpoints";
import { post } from "services/api";

export const validateResetToken = async ({ resetToken }) => {
  await post(`${RAISE_API_V1_URL}/passwords/validate_reset_token`, null, {
    params: {
      reset_password_token: resetToken
    }
  });
};
